import React from 'react';

interface BackgroundMediaProps {
  backgroundPath: string;
  className?: string;
}

const VIDEO_EXTENSIONS = ['mp4', 'mov'] as const;
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'] as const;

export const BackgroundMedia: React.FC<BackgroundMediaProps> = ({
  backgroundPath,
  className = "absolute inset-0 w-full h-full object-cover object-top"
}) => {
  const fileExtension = backgroundPath.split('.').pop()?.toLowerCase();
  
  const isVideo = VIDEO_EXTENSIONS.includes(fileExtension as any);
  const isImage = IMAGE_EXTENSIONS.includes(fileExtension as any);

  if (isVideo) {
    return (
      <video
        src={backgroundPath}
        preload="auto"
        autoPlay
        loop
        muted
        playsInline
        disablePictureInPicture
        className={className}
        style={{ pointerEvents: 'none' }}
      />
    );
  }

  if (isImage) {
    return (
      <img
        src={backgroundPath}
        alt={backgroundPath}
        className={className}
      />
    );
  }

  // Fallback for unknown file types
  return (
    <div className={className} style={{ backgroundColor: '#000' }}>
      <div className="flex items-center justify-center h-full text-white">
        <p>Unsupported media type</p>
      </div>
    </div>
  );
};